import React, { useContext } from 'react';
import '../../node_modules/video-react/dist/video-react.css';
import styled from 'styled-components';
import Context from '../Context';
import { getClip } from '../utils';
import { displayFlex } from '../constants';

const Wrapper = styled.div`
    ${displayFlex}
    width: 40rem;
    height: 25rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    background: black;
`;

const Video = styled.video`
  height: inherit;
`;

export default function VideoStream(props) {
  const { vidIds } = props;

  const {
    sequenceIndex, setSequenceIndex, videoIndex, setVideoIndex,
  } = useContext(Context);

  const onEnded = () => {
    setVideoIndex(videoIndex + 1);
    if (videoIndex + 1 >= vidIds.length) {
      setSequenceIndex(sequenceIndex + 1);
      setVideoIndex(0);
    }
  };

  return (
    <Wrapper>
      <Video
        muted
        autoPlay
        onEnded={onEnded}
        src={getClip(vidIds[videoIndex]).clip}
      />
    </Wrapper>

  );
}
